module.exports = __webpack_public_path__ + "static/uni_kaiser_old-18400f7160773982998cee61af8c1307.png";